import { EventRegistry } from '../../../../../domain/event/event.registry';
import { ReferenceTableEvent } from './reference-table.event';
export class ReferenceTableItemAttributesReplacedEvent extends ReferenceTableEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `reference-table/${payload.referenceTableId}/item/${payload.itemId}`,
            type: ReferenceTableItemAttributesReplacedEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
ReferenceTableItemAttributesReplacedEvent.subject = 'reference-table/aggregate/reference-table/ReferenceTableItemAttributesReplacedEvent';
ReferenceTableItemAttributesReplacedEvent.type = 'com.treeplotter.api.reference-table.item-attributes-replaced.v1';
EventRegistry.register(ReferenceTableItemAttributesReplacedEvent.type, ReferenceTableItemAttributesReplacedEvent);
//# sourceMappingURL=reference-table-item-attributes-replaced.event.js.map